export default __webpack_public_path__ + "static/media/xfinity-black-friday-sale.c0eb5d07.png";